import React from 'react';
import Button from '@atlaskit/button';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { SubtleText } from '../styled.tsx';

type Props = {
	ownerName?: string;
	ownerId?: string;
};

const messages = defineMessages({
	noOwner: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.no-owner',
		defaultMessage: 'No owner',
		description: 'Displayed when a component has no owner attached.',
	},
});

export default function OwnerCell(props: Props) {
	const { ownerName, ownerId } = props;
	const { formatMessage } = useIntl();

	return ownerId && ownerName ? (
		<Button
			testId="project-directories.components.compass-table.cells.owner.link"
			appearance="link"
			spacing="none"
			href={`/compass/people/team/${ownerId}`}
			target="_blank"
			rel="noopener noreferrer"
			onClick={(_, analyticsEvent) => {
				fireUIAnalytics(analyticsEvent, 'ownerLink');
			}}
		>
			{ownerName}
		</Button>
	) : (
		<SubtleText>{formatMessage(messages.noOwner)}</SubtleText>
	);
}
